/**
 * A device's "location on property" as a person should read it — or null when
 * the stored value is a known import artifact, not a location.
 *
 * Audit 2026-10-01: "Information Contact Information" rendered as the device
 * location on several jobs (#072651795, #092678489, #082664668). It is a pair
 * of section headers ("Location Information" / "Contact Information") that the
 * historical test-report parser read as the value after the word "Location"
 * (`pickLineAfter(text, "Location")`, services/historicalReports/
 * parseBackflowReport.ts), and the report importer wrote it into an empty
 * `assets.location_description` (scripts/backflowReportsApplyRun.ts). Issue
 * #1024 made it correctable on the device page; this keeps it off the job page
 * meanwhile. The stored value is untouched — clearing it is a data job.
 *
 * Exact matches only (case and spacing ignored): a real location that merely
 * contains the word "information" must still show.
 */
const JUNK_LOCATIONS = new Set([
    "information contact information",
    "location information contact information",
    "location information",
    "contact information",
]);

export function displayDeviceLocation(raw: string | null | undefined): string | null {
    const v = (raw ?? "").replace(/\s+/g, " ").trim();
    if (!v) return null;
    return JUNK_LOCATIONS.has(v.toLowerCase()) ? null : v;
}
